import { Injectable } from '@angular/core';

/*
  Generated class for the ValidatorProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ValidatorProvider {

  constructor() {
    console.log('Hello ValidatorProvider Provider');
  }

  isValidName(name: string) {
    let nameArray = name.split(" ");

    if (nameArray.length >= 2) {
      return true;
    }

    return false;

  }

  isEmail(email: string) {
    // DONE: Preciso remover o nível de austeridade (Motivo: bruna.-@hotmail.com)
    return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email));
    /*
        // DONE: Verificação menos austera (Motivo: bruna.-@hotmail.com)
        var re1 = '([\\w-+]+(?:\\.[\\w-+]+)*@(?:[\\w-]+\\.)+[a-zA-Z]{2,7})';
        var p = new RegExp(re1);
        var m = p.exec(email);

        return (m != null);
    */
  }

  isEmpty(value: any) {
    if (value === null) {
      return true;
    }

    if (value === undefined) {
      return true;
    }

    if (typeof value === 'string') {
      if (value.trim().length === 0) {
        return true;
      }
    }

    return false;
  }

  isZipcode(zipCode: string) {
    let result = false;

    if (!this.isEmpty(zipCode)) {
      // Trim empty spaces in start and end
      zipCode = zipCode.replace(/^s+|s+$/g, '');

      if (zipCode.length > 0) {
        // 00.000-00
        // let regex = /^[0-9]{2}.[0-9]{3}-[0-9]{3}$/;
        // 00000-00
        let regex = /^[0-9]{5}-[0-9]{3}$/;

        result = regex.test(zipCode);
      }
    }

    return result;
  }

  /**
   * Validate a date.
   *
   * @param date Date in format: dd/mm/yyyy
   */
  isDate(date: string) {
    let dateformat: RegExp = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
    let result: boolean = true;

    // Match the date format through regular expression
    if (date.match(dateformat)) {
      //Test which seperator is used '/' or '-'
      let opera1 = date.split('/');
      let opera2 = date.split('-');
      let lopera1 = opera1.length;
      let lopera2 = opera2.length;

      let pdate = [];

      // Extract the string into month, date and year
      if (lopera1 > 1) {
        pdate = date.split('/');
      } else if (lopera2 > 1) {
        pdate = date.split('-');
      }

      let dd = parseInt(pdate[0]);
      let mm = parseInt(pdate[1]);
      let yy = parseInt(pdate[2]);

      // Create list of days of a month [assume there is no leap year by default]
      let listOfDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (mm == 1 || mm > 2) {
        if (dd > listOfDays[mm - 1]) {
          result = false;
        }
      }

      if ((result) && (mm == 2)) {
        let lyear = false;
        if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
          lyear = true;
        }

        if ((lyear == false) && (dd >= 29)) {
          result = false;
        }

        if ((lyear == true) && (dd > 29)) {
          result = false;
        }
      }
    } else {
      result = false;
    }

    return result;
  }

  isCpf(cpf: string) {
    if (cpf != null) {
      // Fetch only numbers
      cpf = cpf.replace(/[^0-9]/g, '');

      if (cpf.length != 11) {
        return false;
      }

      const BLACKLIST: Array<string> = [
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999',
        '12345678909',
      ];
      if (BLACKLIST.indexOf(cpf) !== -1) {
        return false;
      }

      const verifierDigit: any = (digits: string): number => {
        const numbers: Array<number> = digits
          .split('')
          .map(number => {
            return parseInt(number, 10);
          });
        const modulus: number = numbers.length + 1;
        const multiplied: Array<number> = numbers.map((number, index) => number * (modulus - index));
        const mod: number = multiplied.reduce((buffer, number) => buffer + number) % 11;

        return ((mod < 2) ? 0 : (11 - mod));
      }

      let numbers: string = cpf.substr(0, 9);
      numbers += verifierDigit(numbers);
      numbers += verifierDigit(numbers);

      return (numbers.substr(-2) === cpf.substr(-2));
    } else {
      return false;
    }
  }

  isCnpj(cnpj: string) {
    if (cnpj != null) {
      // Fetch only numbers
      cnpj = cnpj.replace(/[^0-9]/g, '');

      if (cnpj.length != 14) {
        return false;
      }

      const BLACKLIST: Array<string> = [
        '00000000000000',
        '11111111111111',
        '22222222222222',
        '33333333333333',
        '44444444444444',
        '55555555555555',
        '66666666666666',
        '77777777777777',
        '88888888888888',
        '99999999999999',
      ];
      if (BLACKLIST.indexOf(cnpj) !== -1) {
        return false;
      }

      const verifierDigit: any = (digits: string): number => {
        let index: number = 2;
        const reverse: Array<number> = digits.split('').reduce((buffer, number) => {
          return [parseInt(number, 10)].concat(buffer);
        }, []);
        const sum: number = reverse.reduce((buffer, number) => {
          buffer += number * index;
          index = ((index === 9) ? 2 : (index + 1));

          return buffer;
        }, 0);
        const mod: number = sum % 11;

        return ((mod < 2) ? 0 : (11 - mod));
      };

      let numbers: string = cnpj.substr(0, 12);
      numbers += verifierDigit(numbers);
      numbers += verifierDigit(numbers);

      return (numbers.substr(-2) === cnpj.substr(-2));
    } else {
      return false;
    }
  }

  isCourseCodeBradesco(cpf: string, code: string) {
    if ((this.isCpf(cpf)) && (code != null)) {
      // Fetch only numbers
      cpf = cpf.replace(/[^0-9]/g, '');

      const HASHS: Array<String> = [
        'DYhG93b0qy',
        'JfIxfs2guV',
        'oUubWwvniR',
        '2G0FgaC9mi',
        'ABde16Wf2H',
        'p7alm39HG3',
        '57tM884cEZ',
        'L2q6mU5f1x',
        'm99S5bBv4r',
        'Q6gRd42Lc1',
        '1bcY60fKXp',
      ];

      let generatedCode = '';
      for (let i = 0; i < 11; i++) {
        generatedCode += HASHS[i].substr(parseInt(cpf.substr(i, 1), 10), 1);
      }

      return (generatedCode.toLowerCase() === code.toLowerCase());
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/validator/validator.ts